import DfvExpanded from './DfvExpanded';

export default DfvExpanded;
